import React from "react";
import { MandatorConditional } from "@helpers/mandatorConditional";
import { CommunityPosts } from "./CommunityPosts/CommunityPosts";
import { ArivaTimeline } from "./ArivaTimeline";

interface DashboardSidebarSectionProps {
  topPadding?: number;
}

export const DashboardSidebarSection = ({
  topPadding,
}: DashboardSidebarSectionProps) => (
  <>
    <MandatorConditional showFor={["boersennews_de"]}>
      <CommunityPosts topPadding={topPadding} />
    </MandatorConditional>
    <MandatorConditional showFor={["ariva_de"]}>
      <ArivaTimeline topPadding={topPadding} />
    </MandatorConditional>
  </>
);
